// extracted by mini-css-extract-plugin
export default {"wrapper":"DefaultLayout_wrapper__tkNS0","banner":"DefaultLayout_banner__UtWiS","content":"DefaultLayout_content__e9Pwb"};